import { atom, useAtom } from 'jotai'

const visitModalAtom = atom({ isMounted: false, isVisible: false })

const useVisitModal = () => {
  const [visitModal, setVisitModal] = useAtom(visitModalAtom)

  return {
    visitModal,
    setVisitModal,
  }
}

export default useVisitModal
